/* 获取验证码 */
import request from "@/utils/request";
import qs from "qs";

/* 企业定制方案 */
export function submitCompanyCustom(data) {
  return request({
    url: '/?m=Api&a=companyContact',
    method: 'post',
    data: qs.stringify(data)
  })
}
